import axios from "utils/axios";
import type { CustomAxiosRequestConfig } from "@xt/xtbase";

const URL = "/sapi/v4/payment/";

// nft 充值
export function post_nftDeposit(config?: CustomAxiosRequestConfig) {
  return axios.post(URL + `nft/deposit`, null, config);
}

// nft 提现
export function post_nftWithdraw(config) {
  return axios.post(URL + `nft/withdraw`, null, config);
}

// nft 提现配置
export function get_nftWithdrawConfig(config?) {
  return axios.get(URL + `nft/withdraw/config`, config);
}
// nft 充提历史
export function get_nftOrderHistory(config) {
  return axios.get(URL + `nft/order/history`, config);
}

// 获取手续费
export function get_nftWithdrawFee(config) {
  return axios.get(URL + `nft/withdraw/fee`, config);
}

// 获取用户支付方式列表
export function get_fiatPaymentMethodUserList(config?: CustomAxiosRequestConfig) {
  return axios.get(URL + `fiat/payment-method/user/list`, config);
}

// 获取法币列表（提现用）
export function get_fiatListForWithdraw(config?: CustomAxiosRequestConfig) {
  return axios.get(URL + `fiat/list/withdraw`, config);
}

// 获取支付方式列表（提现用）
export function get_fiatPaymentMethodListForWithdraw(config?: CustomAxiosRequestConfig) {
  return axios.get(URL + `fiat/payment-method/list/withdraw`, config);
}

// 配置用户支付方式（按组保存，一次提交）
export function post_fiatConfigureUserPaymentMethod(config?: CustomAxiosRequestConfig) {
  return axios.post(URL + `fiat/payment-method/user/group/configure`, null, config);
}

// 删除用户支付方式（按组）
export function delete_fiatUserPaymentMethod(groupKey: string, config?: CustomAxiosRequestConfig) {
  return axios.delete(URL + `fiat/payment-method/user/group`, {
    ...(config || {}),
    params: {
      ...(config?.params || {}),
      groupKey,
    },
  });
}

